import React from 'react';

const SelectIcon: React.FC = () => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.00842 9.61108L7.19885 12.696L13.2135 5.22534" stroke="white" strokeWidth="1.4" />
    </svg>
  );
};

export default SelectIcon;
